<template>
  <OurPage :back-route="backRoute" :title="$t('title.survey.add')" width="md">
    <SurveyForm ref="surveyForm" v-model="form" />

    <template #footer-left>
      <OurButton class="button" :text="$t('button.save')" @click="onClickSaveButton" />
      <OurLink :route="backRoute">
        <OurButton class="button" :text="$t('button.back')" variant="secondary" />
      </OurLink>
    </template>
  </OurPage>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";
import SurveyForm from "@/views/settings/survey/add/_components/SurveyForm.vue";
import { createSurveyMutation } from "@/views/settings/survey/add/gql/mutations";

export default {
  name: "SurveyAdd",
  components: { SurveyForm },
  mixins: [apolloMixin],
  data() {
    return {
      backRoute: {
        name: "SettingsSurvey",
        title: this.$t("title.survey._"),
      },
      form: {
        title: "",
        text: "",
        buttonText: "Детальніше",
        url: "",
        startsAt: null,
        endsAt: null,
        maxShows: 1,
      },
    };
  },
  methods: {
    async onClickSaveButton() {
      this.$refs.surveyForm.emitForm();

      if (!this.form.isValid) {
        return;
      }

      const { title, text, buttonText, url, startsAt, endsAt, maxShows } = this.form;

      const variables = {
        title,
        text,
        buttonText,
        url,
        startsAt,
        endsAt,
      };

      if (maxShows !== 1) {
        variables.maxShows = maxShows;
      }

      const { createSurvey } = await this.$post(createSurveyMutation, variables, {
        delaySuccessNotify: true,
      });

      if (createSurvey?.id) {
        await this.$router.push({ name: "SettingsSurvey" });
      }
    },
  },
};
</script>
